<h1 class="mat-display-1 pb-2 m-0 component-header">Quote Requests</h1>

<mat-card>
	<rpfsa-quote-list-filters [formControl]="filter">
	</rpfsa-quote-list-filters>
	<table
		mat-table
		class="list-container mb-3"
		[dataSource]="pagedQuotes$ | async"
		matSort
		matSortActive="{{ sort.active }}"
		matSortDisableClear
		matSortDirection="{{ sort.direction }}"
	>
		<ng-container matColumnDef="empty">
			<th
				mat-header-cell
				*matHeaderCellDef
				[colSpan]="resultColumns.length"
				class="text-center"
			>
				<div *ngIf="isLoading$ | async" class="list-loader">
					<mat-progress-bar mode="indeterminate"></mat-progress-bar>
				</div>
				<em> {{ listMessage$ | async }}</em>
			</th>
		</ng-container>

		<ng-container matColumnDef="number">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Number</th>
			<td mat-cell *matCellDef="let quote">
				<a [routerLink]="quotesFragments.detail(quote.id)">
					{{ quote.number }}
				</a>
			</td>
		</ng-container>
		<ng-container matColumnDef="start">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>
				Start Date
			</th>
			<td mat-cell *matCellDef="let quote">
				{{ quote.start | date: 'MM/dd/yyyy':'utc' }}
			</td>
		</ng-container>
		<ng-container matColumnDef="customer">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Customer</th>
			<td mat-cell *matCellDef="let quote">
				<a
					*ngIf="quote.customer; else noCustomer"
					[routerLink]="customersFragments.detail(quote.customer?.id)"
				>
					{{ quote.customer?.name }}
				</a>
				<ng-template #noCustomer></ng-template>
			</td>
		</ng-container>
		<ng-container matColumnDef="railroad">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Railroad</th>
			<td mat-cell *matCellDef="let quote">
				<a
					*ngIf="quote.railroad; else noRailroad"
					[routerLink]="railroadsFragments.detail(quote.railroad?.id)"
				>
					{{ quote.railroad?.code }}
				</a>
				<ng-template #noRailroad></ng-template>
			</td>
		</ng-container>
		<ng-container matColumnDef="quoteStatus">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
			<td mat-cell *matCellDef="let quote">
				{{ displayQuoteStatus[quote.quoteStatus] }}
			</td>
		</ng-container>
		<ng-container matColumnDef="modified">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>
				Last Modified
			</th>
			<td mat-cell *matCellDef="let quote">
				{{ quote?.lastModified | date: 'MM/dd/yy h:mm a' }}
			</td>
		</ng-container>
		<ng-container matColumnDef="description">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>
				Description
			</th>
			<td mat-cell *matCellDef="let quote">{{ quote.description }}</td>
		</ng-container>

		<ng-container matColumnDef="delete">
			<th mat-header-cell *matHeaderCellDef></th>
			<td mat-cell *matCellDef="let quote">
				<button
					mat-icon-button
					color="warn"
					rpsharedConfirm="This action will permanently cancel this quote. Do you wish to continue?"
					(onConfirmed)="cancelQuote(quote.id)"
					matTooltip="Cancel Quote"
					matTooltipPosition="left"
				>
					<mat-icon>delete_forever</mat-icon>
				</button>
			</td>
		</ng-container>

		<tr
			mat-header-row
			*matHeaderRowDef="resultColumns"
			[class.hidden]="listMessage$ | async"
		></tr>
		<tr
			mat-header-row
			*matHeaderRowDef="emptyColumns"
			[class.hidden]="!(listMessage$ | async)"
		></tr>
		<tr
			mat-row
			*matRowDef="let quote; columns: resultColumns"
			[@animateList]
		></tr>
	</table>

	<div fxLayout fxLayoutAlign="space-between center">
		<mat-paginator [length]="pagedQuotesCount$ | async"> </mat-paginator>
		<button
			class="mr-4"
			mat-mini-fab
			color="primary"
			[routerLink]="quotesFragments.detail(0)"
			matTooltip="Add Quote"
		>
			<mat-icon>add</mat-icon>
		</button>
	</div>
</mat-card>
